export const $MAX_WIDTH = 900;
